import enFlag from "../../../../img/enFlag.png?width=50px";
import FlagOptionBase from "../../abstracts/flagOptionBase";
import flagItemModal from "./flagItem";

export default class EnFlagOpt extends FlagOptionBase{
    private static titleLegend = "English";
    private static idOption = "op-en";
    private static elementToRender = flagItemModal(enFlag,EnFlagOpt.titleLegend);

    constructor(protected modalBody:HTMLElement){
        super(modalBody,EnFlagOpt.idOption,EnFlagOpt.elementToRender);
    }

    translateAction(){
        localStorage.setItem("i18n","en");
    }
}